import { render, staticRenderFns } from "./deduct-shelfcost.vue?vue&type=template&id=9ecf65e4"
import script from "./deduct-shelfcost.vue?vue&type=script&lang=ts"
export * from "./deduct-shelfcost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports